<mat-card>
  <mat-card-content>
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true">
        <div class="wrap-mat-title">
          <ng-container *ngIf="!isPassport">
            <h1 class="mat-title">{{'kyc.sign_EKYC_camera_title' | translate}}<span
                style="color: #ef3f69; font-size: 20px">*</span></h1>
            <button type="button" class="close" aria-label="Close" (click)="onCloseDialog()">
              <span aria-hidden="true">&times;</span>
            </button>
          </ng-container>
          <ng-container *ngIf="isPassport">
            <h1 class="mat-title">{{'kyc.sign_EKYC_camera_passport_title' | translate}}<span
                style="color: #ef3f69; font-size: 20px">*</span></h1>
            <button type="button" class="close" aria-label="Close" (click)="onCloseDialog()">
              <span aria-hidden="true">&times;</span>
            </button>
          </ng-container>
          <mat-divider inset="true"></mat-divider>
        </div>
        <div style="max-height: 75vh; overflow: auto;" class="row d-flex justify-content-between ekyc-box">
          <div class="col-md-12 col-lg-8 pt-5 pb-5">
            <div class="info-wrap">
              <div class="face">
                <div class="icon" (click)="handleCamera(typeCamera.face)"
                  matTooltip="{{'kyc.tooltip_face' | translate}}">
                  <img src="assets/images/icon-camera.png" alt="camera">
                </div>
                <div class="img" (click)="zoomImage(typeCamera.face)">
                  <img *ngIf="faceImage" [src]="faceImage.imageAsDataUrl" />
                </div>
                <div class="text-center">
                  <span class="txt">{{'kyc.image_face' | translate}}</span> <span style="color: red">*</span><br>
                  <span *ngIf="checkFaceImage" style="color: #FF0000">{{'kyc.image_face_required' | translate}}</span>
                </div>
              </div>
              <div class="cccd mt-5">
                <div class="cccd_before" *ngIf="!isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.before)"
                    matTooltip="{{'kyc.tooltip_before' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.before)">
                    <img *ngIf="cccdBeforeImage" [src]="cccdBeforeImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_before' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkCccdBeforeImage" style="color: #FF0000">{{'kyc.image_before_required' |
                      translate}}</span>
                  </div>
                </div>
                <div class="cccd_after" *ngIf="!isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.after)"
                    matTooltip="{{'kyc.tooltip_after' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.after)">
                    <img *ngIf="cccdAfterImage" [src]="cccdAfterImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_after' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkCccdAfterImage" style="color: #FF0000">{{'kyc.image_after_required' |
                      translate}}</span>
                  </div>
                </div>
                <div class="passport cccd_after" *ngIf="isPassport">
                  <div class="icon" (click)="handleCamera(typeCamera.passport)"
                    matTooltip="{{'kyc.tooltip_passport' | translate}}">
                    <img src="assets/images/icon-camera.png" alt="camera">
                  </div>
                  <div class="img" (click)="zoomImage(typeCamera.passport)">
                    <img *ngIf="passportImage" [src]="passportImage.imageAsDataUrl" />
                  </div>
                  <div class="text-center">
                    <span class="txt">{{'kyc.image_passport' | translate}}</span> <span style="color: red">*</span><br>
                    <span *ngIf="checkPassportImage" style="color: #FF0000">{{'kyc.image_passport_required' |
                      translate}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-4 pt-5 pb-5 pr-2">
            <div class="camera-wrap" id="camera-view">
              <div class="title-camera">
                <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.face">{{'kyc.capture_face' |
                  translate}}</ng-container>
                <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.before">{{'kyc.capture_before'
                  | translate}}</ng-container>
                <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.after">{{'kyc.capture_after' |
                  translate}}</ng-container>
                <ng-container *ngIf="typeCameraChoose && typeCameraChoose === typeCamera.passport">
                  {{'kyc.image_passport' | translate}}</ng-container>
              </div>
              <div class="webcam text-center">
                <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
                  [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                  [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
                  (initError)="handleInitError($event)">
                </webcam>
              </div>

              <div class="group-btn mt-3">
                <button mat-stroked-button color="primary" class="mr-3" (click)="triggerSnapshot()"
                  [disabled]="checkCapture || errors.length > 0">
                  <img width="22" src="assets/images/icon-camera.png" alt="camera">
                  {{'kyc.capture' | translate}}
                </button>
                <button mat-stroked-button color="primary" class="mr-3" (click)="captureAgain()"
                  [disabled]="checkCaptureAgain">
                  <mat-icon class="mr-0">replay</mat-icon>
                  {{'kyc.capture_again' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div style="color: red" class="pb-3" *ngIf="errors.length > 0">{{ 'kyc.no_camera' | translate }}</div>

        <div class="d-flex justify-content-center">
          <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button" (click)="onCloseDialog()">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{ "button.cancel" | translate }}
          </button>
  
          <button mat-raised-button color="primary" class="mr-3" (click)="sign()">
            <mat-icon class="mr-0">gesture</mat-icon>
            <span *ngIf="!isSignDigitalCertificate">{{ "enterprise_contract.buttons.sign" | translate
              }}</span>
            <span *ngIf="isSignDigitalCertificate">{{ "enterprise_contract.buttons.approve" | translate
              }}</span>
          </button>
        </div>

      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>

<!-- The Modal -->
<div id="myModal" class="modal" *ngIf="modalImage">
  <span class="close-zoom-image" (click)="closeZoomImage()">&times;</span>
  <img [src]="modalImage.imageAsDataUrl" />
</div>